/**
 * US 6469 — the shift placement-fee "Note" message.
 *
 * This copy used to be built inline on the Post Shift entry flow (Create Shift /
 * Create Dental Shift). The pop-up was removed from that flow and moved to the
 * per-location "View Rates" action on Payment Settings, so the message now lives
 * here and is built from the location's own commission configuration.
 */
export const getShiftPlacementFeeMessage = (location: any): string => {
  if (!location) {
    return "";
  }

  if (location.commissionType === "percentage") {
    return `Posting shifts is free of charge. However, if you accept an applicant for your shift(s), a placement fee of ${location.commissionPercentage}% per hour will be charged once the shift is completed. The placement fee is charged on a per-shift basis, with a maximum of $${location.commissionMaximum} and a minimum of $${location.commissionMinimum}.`;
  }

  const isFixedHourly = location.isFixedHourlyRate === true;
  const feeText = isFixedHourly
    ? `$${location.commission} per hour`
    : `$${location.commission}/shift`;
  const basisText = isFixedHourly ? "per hour" : "per shift";
  const feeLimitText = isFixedHourly
    ? ` The placement fee is charged on a ${basisText} basis, with a maximum of $${location.commissionMaximum} and a minimum of $${location.commissionMinimum}.`
    : ` The placement fee is charged on a ${basisText} basis.`;

  return `Posting shifts is free of charge. However, if you accept an applicant for your shift(s), a placement fee of ${feeText} will be charged when the shift is completed.${feeLimitText}`;
};

/**
 * True when the location carries enough commission configuration to render a
 * correct fee sentence. Guards the "View rates" row: before US 6469 this copy
 * was only ever built for the one location the owner was posting under, which
 * had already passed the approval and payment gates. The row now offers it for
 * every location on the account — including ones that are under review or newly
 * added — so a location with no commission configured must hide the row rather
 * than render "$undefined".
 */
export const hasShiftPlacementFeeInfo = (location: any): boolean => {
  if (!location) {
    return false;
  }
  if (location.commissionType === "percentage") {
    return location.commissionPercentage !== null && location.commissionPercentage !== undefined;
  }
  if (location.commissionType === "fixed") {
    return location.commission !== null && location.commission !== undefined;
  }
  return false;
};
